module.exports = "/fonts/vendor/roboto-fontface/roboto/Roboto-Light.woff2?d26871e8149b5759f814fd3c7a4f784b";